import React, { useEffect, useState, useRef, useContext } from "react";
import moment from "moment";
import { ApiService } from "../../../Component/services/apiServices";
import AccountHeader from "../../../Component/Header/account_header";
import DataContext from "../../../Component/context";
import WalletModal from "../../../Component/Modals/wallet_add_modal";
import { Table } from 'react-bootstrap';
import Footer from "../../../Component/Footer";

const UserWallet = () => {
  const contextValues = useContext(DataContext);
  const [walletblnce, setwalletblnce] = useState()
  const [wallethistory, setwallethistory] = useState([])
  const didMountRef = useRef(true);
  useEffect(() => {
    if (didMountRef.current) {
      ApiService.fetchData("wallet-balance").then((res) => {
        if (res?.status === "success") {
          setwalletblnce(res?.wallet_balance)
        }
      }).catch((err) => { })

      ApiService.fetchData("wallet-history").then((res) => {
        if (res?.status === "success") {
          setwallethistory(res?.rowWalletInfo)
        }
      }).catch((err) => { })
    }
    didMountRef.current = false;
  }, [])

  const toggleWalletModal = () => {
    contextValues.setToggleWalletModal(!contextValues.toggleWalletModal)
  }

  return (<>
    <AccountHeader heading={'My Wallet'}></AccountHeader>
    <div id="appCapsule">
      <div className="p-15">
    <div className="ccpanel">
      <div className="ccpanel-body">
        <div className="walletbox">
          <div className="d-flex align-items-center" style={{ gap: '10px' }}>
            <i className="ri-wallet-2-fill" style={{ fontSize: '32px' }}></i>
            <h4 className="mb-0">My Wallet</h4>
          </div>
          <h6 className="mt-20"> Available Balance </h6>
          <div className="walletbox-balance">${Number(walletblnce)}</div>
        </div>
      </div>
      <div className="ccpanel-footer text-center">
        <button className="btn btn-outline-primary btn-md mt-10" onClick={() => { toggleWalletModal() }} >  <i className="ri-add-circle-line"></i> Add Money </button>
      </div>
    </div>
    {wallethistory?.length > 0 &&
      <div className="ccpanel mt-4">
        <div className="ccpanel-header">
          <h5 className="mb-0">Recent Transactions</h5>
        </div>
        <div className="ccpanel-body p-0">
          <div className="card-table-section">
            <div className="table-responsive">
              <Table striped bordered hover responsive="sm">
                <thead>
                  <tr>
                    <th>Transaction Id</th>
                    <th>Type</th>
                    <th className="text-center">Mode</th>
                    <th className="text-center">Date</th>
                    <th className="text-center">Opening Balance</th>
                    <th className="text-center">Amount</th>
                    <th className="text-center">Closing Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {wallethistory?.map((items, index) => (
                    <tr key={index}>
                      <td className="text-center">{items?.uw_order_id}</td>
                      <td className="text-center">
                        {items?.uw_trans_type === 'P' ? 'Credit' : 'Debit'}
                      </td>
                      <td className="text-center">
                        {items?.uw_add_type === 1 ? 'Card' : 'Card'}
                      </td>
                      <td className="text-center">
                        {moment(items?.created_at).format('DD-MM-YYYY')}
                      </td>
                      <td className="text-center">{items?.uw_last_bal}</td>
                      <td className="text-center">
                        {(items?.uw_trans_type === 'P' ? '+' : '-') + items?.uw_amount_add}
                      </td>
                      <td className="text-center">{items?.uw_after_bal}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    }
</div>
    </div>
   
    <Footer />
    {contextValues.toggleWalletModal && <WalletModal />}
  </>
  )
}

export default UserWallet